// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'star';

export const Component = () => (
  <path d='m23.581 9.395-7.34-1.168-3.319-6.447c-.094-.186-.233-.28-.42-.28-.234 0-.375.094-.422.233L8.761 8.226l-7.34 1.168C1.141 9.44 1 9.627 1 9.86c0 .14.047.28.14.373l5.61 4.952-1.543 7.753v.094c0 .327.14.467.468.467.094 0 .187 0 .233-.046l6.545-3.41 6.592 3.41c.047.046.094.046.234.046.327 0 .467-.14.467-.467v-.094l-1.496-7.753 5.563-4.952c.14-.14.187-.233.187-.373 0-.233-.14-.42-.421-.467h.002Zm-1.168.794-4.815 4.297-.421.373 1.402 7.287-6.124-3.177-6.125 3.177 1.449-7.287-5.236-4.67 6.825-1.121.234-.42L12.5 3.041l3.086 6.026 6.825 1.12h.002Z' />
);

export const viewBox = '0 0 25 25';
